export default "__VITE_ASSET__bbbf0da2__"